export default {
  strict: true,
  namespaced: true,
  state: {
    // エリアの状態
    placeId: 1,
    buildingId: 1,
    floorId: 1,
    destinationId: null,
    destinationType: null,
    // 地図の状態
    mapZoomLevel: 1,
    isGroupSelected: false,
  },
  mutations: {
    setPlaceId(state, id) {
      state.placeId = id;
    },
    setBuildingId(state, id) {
      state.buildingId = id;
    },
    setFloorId(state, id) {
      state.floorId = id;
    },
    setDestination(state, destination) {
      state.destinationId = destination.id;
      state.destinationType = destination.type;
    },
    switchGroupSelected(state, value) {
      state.isGroupSelected = value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/views/current.js